import { createReducer } from 'redux-act';

import {
  LOGS_FETCH_DATA_INIT,
  LOGS_FETCH_DATA_SUCCESS,
  LOGS_FETCH_DATA_FAIL,
} from 'state/actionCreators/logs';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
};

export const logsReducer = createReducer(
  {
    [LOGS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [LOGS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [LOGS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
  },
  initialState
);
